export default __webpack_public_path__ + "static/media/boxicons.dcaf6a26.woff";